import styled from 'styled-components';

export const Title = styled.span`
    font-size: 17px;
    font-weight: bold;
    margin-bottom: 4px;
    color: currentColor;
    flex-shrink: 0;
`;